import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

const PrimaryButton = ({ 
  children, 
  onClick, 
  disabled = false, 
  fullWidth = false,
  size = 'medium',
  startIcon,
  endIcon,
  ...props 
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        backgroundColor: 'var(--primary)',
        color: '#FFF',
        fontWeight: 500,
        textTransform: 'none',
        borderRadius: 2,
        boxShadow: 'var(--primary-shadow)',
        '&:hover': {
          backgroundColor: 'var(--primary-hover)',
          boxShadow: '0 4px 14px rgba(108,179,63,0.35)'
        },
        '&:active': {
          transform: 'scale(0.98)'
        },
        '&:disabled': {
          opacity: 0.6,
          cursor: 'not-allowed'
        },
        transition: 'all 0.3s ease',
        ...props.sx
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  sx: PropTypes.object
};

export default PrimaryButton;